import { Facebook, Instagram, Mail, MessageCircle, Music2 } from "lucide-react";
import { Link } from "react-router-dom";

const SOCIAL_LINKS = [
  { label: "Facebook", href: "https://www.facebook.com/Carmine.Lucariello.1981", icon: Facebook, testId: "footer-social-facebook" },
  { label: "Instagram", href: "https://www.instagram.com/orologi.preziosi", icon: Instagram, testId: "footer-social-instagram" },
  { label: "WhatsApp", href: "https://wa.me/393511997843", icon: MessageCircle, testId: "footer-social-whatsapp" },
  { label: "Email", href: "mailto:carminelucariello@yahoo.it", icon: Mail, testId: "footer-social-email" },
  { label: "TikTok", href: "https://www.tiktok.com/@carmine.lucariello", icon: Music2, testId: "footer-social-tiktok" },
];

export default function Footer() {
  return (
    <footer className="border-t border-line bg-void">
      <div className="px-6 py-20 lg:px-12">
        <img src="/media/logo-full.png" alt="Logo Orologi e Preziosi" className="h-28 w-28 object-contain lg:h-32 lg:w-32" data-testid="footer-logo-image" />
        <div className="mt-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">Collezione</p>
            <ul className="mt-6 space-y-3 text-sm text-muted">
              <li>
                <Link to="/catalogo?categoria=orologi" data-testid="footer-orologi" className="transition-colors duration-500 hover:text-ivory">
                  Orologi
                </Link>
              </li>
              <li>
                <Link to="/catalogo?categoria=gioielli" data-testid="footer-gioielli" className="transition-colors duration-500 hover:text-ivory">
                  Gioielli
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">Contatti</p>
            <ul className="mt-6 space-y-3 text-sm text-muted">
              <li>Via Diomede Carafa 62, 80124 Napoli</li>
              <li className="font-mono text-xs">+39 351 199 7843</li>
              <li>
                <a href="mailto:carminelucariello@yahoo.it" data-testid="footer-email" className="font-mono text-xs transition-colors duration-500 hover:text-gold">
                  carminelucariello@yahoo.it
                </a>
              </li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">Social</p>
            <div className="mt-6 flex flex-wrap gap-3" data-testid="footer-social-links">
              {SOCIAL_LINKS.map(({ label, href, icon: Icon, testId }) => (
                <a
                  key={label}
                  href={href}
                  target={href.startsWith("mailto:") ? undefined : "_blank"}
                  rel={href.startsWith("mailto:") ? undefined : "noreferrer"}
                  aria-label={label}
                  data-testid={testId}
                  className="flex h-11 w-11 items-center justify-center rounded-full border border-line text-muted transition-all duration-500 hover:-translate-y-1 hover:border-gold hover:text-gold"
                >
                  <Icon size={17} strokeWidth={1.5} />
                </a>
              ))}
            </div>
            <p className="mt-5 text-sm leading-relaxed text-muted">
              Seguici sui canali social per nuovi arrivi e disponibilità.
            </p>
          </div>
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">Garanzie</p>
            <ul className="mt-6 space-y-3 text-sm text-muted">
              <li>Orologi certificati e garantiti 12 mesi</li>
              <li>Spediamo in tutto il mondo</li>
              <li>Contatto diretto su WhatsApp</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="flex flex-wrap items-center justify-between gap-3 border-t border-line px-6 py-6 lg:px-12">
        <p className="font-mono text-[11px] text-muted">© 2026 Orologi e Preziosi — Napoli · P.IVA 09891821218</p>
        <div className="flex flex-wrap items-center gap-6">
          <Link to="/privacy-policy" data-testid="footer-privacy-link" className="font-mono text-[11px] text-muted transition-colors duration-500 hover:text-gold">
            Privacy Policy
          </Link>
          <Link to="/cookie-policy" data-testid="footer-cookie-link" className="font-mono text-[11px] text-muted transition-colors duration-500 hover:text-gold">
            Cookie Policy
          </Link>
          <Link to="/admin" data-testid="footer-admin-link" className="font-mono text-[11px] text-muted transition-colors duration-500 hover:text-gold">
            Area Riservata
          </Link>
        </div>
      </div>
    </footer>
  );
}
